import styled from 'styled-components/macro'

const SectionHeading = styled.h5`
  display: block;
  color: ${({ theme }) => theme.tertiaryText};
  font-weight: bold;
  margin-block: 20px 10px;
  margin-inline-end: 5px;
`

export default SectionHeading
